import React, { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import { Col, Form, FormGroup, Label, ModalFooter, Row } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { hotelConfigSelector } from "./hotelConfigSlice";
import { editHotel, fetchHotelConfig } from "./api";
import { toast } from "react-toastify";

const URLHotel = () => {
  const dispatch = useDispatch();

  const { hotelConfigData, isLoading, status } =
    useSelector(hotelConfigSelector);
  console.log("isLoading:", isLoading);
  console.log("status:", status);
  console.log("hotelConfigData:", hotelConfigData);

  useEffect(() => {
    dispatch(fetchHotelConfig());
  }, []);

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: useMemo(() => {
      return hotelConfigData;
    }, [hotelConfigData]),
  });

  const functionCB = (data) => {
    if (data.success == true) {
      return toast.success(data.result?.message || "Sccessful");
    } else if (data.success == false) {
      return toast.error(
        data.result?.message ||
          "Oops.. Something went wrong Please try again later"
      );
    }
  };

  const onSubmit = (data) => {
    console.log(data);
    if (hotelConfigData) {
      dispatch(editHotel({ ...data, CB: functionCB }));
    }
  };

  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
        <Row>
          <Col>
            <FormGroup>
              <Label>{"Why SignIn Url:"}</Label>
              <textarea
                className="form-control"
                name="whySignIn"
                {...register("whySignIn", { required: true })}
              />
              <span style={{ color: "#ff5370" }}>
                {errors.why_signIn_url && "Why signin URL is required"}
              </span>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label>{"Loyalty Link:"}</Label>
              <textarea
                className="form-control"
                name="loyaltyLink"
                {...register("loyaltyLink", { required: true })}
              />
              <span style={{ color: "#ff5370" }}>
                {errors.loyalty_link && "Loyalty link is required"}
              </span>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label>{"Terms And Condition Url:"}</Label>
              <textarea
                className="form-control"
                name="termsAndConditionUrl"
                {...register("termsAndConditionUrl", { required: true })}
              />
              <span style={{ color: "#ff5370" }}>
                {errors.terms_condition_url &&
                  "Terms and condition URL is required"}
              </span>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Label>{"About Hotel Url:"}</Label>
              <textarea
                className="form-control"
                name="aboutHotelUrl"
                {...register("aboutHotelUrl", { required: true })}
              />
              <span style={{ color: "#ff5370" }}>
                {errors.about_hotel_url && "About hotel URL is required"}
              </span>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label>{"Hotel Website:"}</Label>
              <textarea
                className="form-control"
                name="hotelWebsite"
                {...register("hotelWebsite", { required: true })}
              />
              <span style={{ color: "#ff5370" }}>
                {errors.hotel_website && "Hotel aboult URL is required"}
              </span>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label>{"Cloudinary Url:"}</Label>
              <textarea
                className="form-control"
                name="url"
                {...register("url", { required: true })}
              />
              <span style={{ color: "#ff5370" }}>
                {errors.cloudinary_url && "Hotel aboult URL is required"}
              </span>
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col>
            <ModalFooter>
              <Btn
                attrBtn={{
                  color: "primary",
                  // onClick: props.togglerSave,
                }}
              >
                SaveChanges
              </Btn>
            </ModalFooter>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default URLHotel;
